/* 异步加载 一些弹窗组件 */
// const TerrainElevationTree = () => import('./terrainModifyTree/TerrainElevationTree');

//按需加载
import {} from "../../../api/api";

// import {
// 	EventBus
// } from '../../../static/js/event-bus.js';

export default {
  components: {
    // TerrainElevation
  },
  props: {},
  data() {
    return {
      terrainModify_show: true,

      treeData: [],
      defaultProps: {
        children: "children",
        label: "modifyName",
      },
      checkedIds: [], //页面加载时默认勾选的id
      isFold: false,
    };
  },
  mounted() {
    this.initTreeData();
    // console.log(this.checkedIds);
    // console.log(88888888888888)
  },

  methods: {
    // 初始化列表
    initTreeData() {
      let that = this;
      //对treeData进一步处理，获取到checkedIds。
      this.recursionProjectGisModify2(this.$GLOBAL.terrainModifyTree);
      this.treeData = this.$GLOBAL.terrainModifyTree;

      // console.log(JSON.parse(JSON.stringify(this.$GLOBAL.terrainModifyTree)));
      // console.log(777777777);
    },
    recursionProjectGisModify2(data) {
      data.forEach((item) => {
        //this.$GLOBAL.checkedIds.push(item.id);
        if (item.children.length > 0) {
          this.recursionProjectGisModify2(item.children);
        } else {
          // console.log(item);
          // console.log(JSON.parse(JSON.stringify(item)));
          // console.log(222222222222);
          //没有子项时做的操作
          if (!item.type) {
            if (item.isDisplay) {
              //展示数据
              this.checkedIds.push(item.id);
            }
          } else {
            //为目录
          }
        }
      });
      // this.$GLOBAL.terrainModifyTree = data;
      this.$GLOBAL.terrainModifyTree = data;
      //return data;
    },
    handleCheck(data, status) {
      //修改节点的选中状态时触发。
    },
    nodeClick(data) {
      this.$refs.terrainModifyTree.setCurrentKey(data.id);
      // console.log(data);
      // console.log(313333333333333);
      if (data.uid) {
        let terrainClip = this.$GLOBAL.map.getThing(data.uid);
        if (data.areaid) {
          let terrainClipArea = terrainClip.getAreaById(data.areaid);
          if (terrainClipArea) {
            this.$GLOBAL.map.flyToPositions(terrainClipArea.positions, {
              minHeight: 1000,
            });
          } else {
            this.$alert(
              "该项未勾选，或者其坐标数组有误，无法为您定位。",
              "友情提示",
              {
                confirmButtonText: "确定",
                type: "warning",
                callback: (action) => {},
              }
            );
          }

          //terrainClipArea.flyTo();//这样写会报错哦。
        } else {
          this.$GLOBAL.map.flyToPositions(terrainClip.positions);
        }
      } else {
        this.$alert(
          "该项未勾选，或者其坐标数组有误，无法为您定位。",
          "友情提示",
          {
            confirmButtonText: "确定",
            type: "warning",
            callback: (action) => {},
          }
        );
      }
    },
    handleCheckChange(data2, status) {
      let that = this;
      //alert(2);
      // console.log(JSON.parse(JSON.stringify(data2)));
      // console.log(666666666);
      // return false;
      if (!data2.type) {
        if (!status) {
          // console.log(this.$GLOBAL.map);
          //let tileLayer
          let terrainClip;
          if (data2.uid) {
            terrainClip = this.$GLOBAL.map.getThing(data2.uid);
          } else {
            //如果挖洞工具已销毁则重新创建
            terrainClip = new mars3d.thing.TerrainClip({
              splitNum: 50, //井边界插值数
            });
            that.$GLOBAL.map.addThing(terrainClip);
          }
          if (terrainClip && data2.areaid) {
            terrainClip.removeArea(data2.areaid);
            this.recursionUpdate(
              this.$GLOBAL.terrainModifyTree,
              data2.areaid,
              data2.modifyType,
              false,
              terrainClip.id,
              0
            );
          }

          // alert(data2.uid);
          // console.log(5555555555);
          // let i = 0;
          // for (var k in this.$GLOBAL.map._layerCache) {
          // 	i++;
          // }
          // console.log(i);
        } else {
          // console.log(JSON.parse(JSON.stringify(this.treeData)));
          //如果存在地形修改json数据文件链接。
          //let fileUrl = "/baseIP/" + data2.modifyUrl;
          let fileUrl = this.$GLOBAL.localResourcesPath + data2.modifyUrl;

          $.ajaxSettings.async = false; //设置getJson同步,否则会异步。
          $.getJSON(fileUrl, function(data) {
            let dataArr = [];
            for (let i = 0; i < data.length; i++) {
              for (let j = 0; j < data[i].terrainModifier.length; j++) {
                dataArr.unshift(JSON.parse(data[i].terrainModifier[j].point));
              }
            }
            if (data2.modifyType === 0) {
              //挖洞。
              if (dataArr.length >= 3) {
                let terrainClip;
                if (data2.uid) {
                  terrainClip = that.$GLOBAL.map.getThing(data2.uid);
                } else {
                  //勾选的项没有data2.uid则获取页面创建时的地形修改工具id。
                  terrainClip = that.$GLOBAL.map.getThing(
                    that.$GLOBAL.terrainModifyClipId
                  );
                  if (!terrainClip) {
                    //如果没有已创建挖洞工具则重新创建。
                    terrainClip = new mars3d.thing.TerrainClip({
                      splitNum: 50, //井边界插值数
                    });
                    that.$GLOBAL.map.addThing(terrainClip);
                  }
                }
                if (terrainClip) {
                  if (dataArr.length >= 3) {
                    let tempObj = terrainClip.addArea(dataArr, {
                      diffHeight: data2.depth,
                    });
                    data2.uid = terrainClip.id;
                    data2.areaid = tempObj.id;
                  }
                } else {
                  data2.uid = 0;
                  data2.areaid = 0;
                }

                that.recursionUpdate(
                  that.$GLOBAL.terrainModifyTree,
                  data2.areaid,
                  data2.modifyType,
                  true,
                  terrainClip.id,
                  data2.areaid
                );
              }
            } else if (data2.modifyType === 1) {
              //压平。
            }
          });
          $.ajaxSettings.async = true; //设置getJson异步,不然会影响别的地方的需要异步执行的代码。
          // console.log(6666666666);
          // console.log(JSON.parse(JSON.stringify(this.treeData)));
        }
      } else {
        //为目录
      }
    },
    //修改数结构数据里对应项的显示属性,方便用户关闭弹窗再打开后，目录树的勾选状态与上次操作结果一致。
    recursionUpdate(data, id, type, show, uid, areaId) {
      //alert(1)
      data.forEach((item) => {
        if (item.children.length > 0) {
          this.recursionUpdate(item.children, id, type, show, uid, areaId);
        } else {
          if (type === 0) {
            //为挖洞。
            if (item.areaid && item.areaid === id) {
              item.isDisplay = show;
              if (uid) {
                item.uid = uid;
              }
              if (areaId) {
                item.areaid = areaId;
              }
            }
          } else if (type === 1) {
            //为压平。
            // if(item.areaid&&item.areaid===id){
            // 	item.isDisplay=show;
            // }
          }
        }
      });
      this.$GLOBAL.terrainModifyTree = data;
    },

    terrainModify_click() {
      this.$emit("terrainModifyBox_close");
    },
    // test(){
    // 	console.log(2)
    // }
  },
  destroyed() {
    // let terrainClip=this.$GLOBAL.map.getThing(data2.uid);
    // terrainClip.clear();
    // this.$GLOBAL.map.removeThing(terrainClip,true);
  },
  watch: {},
};
//console.log(localStorage.getItem(ColorPicker));
